import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface HealthScoreAssetState {
  isLoading: boolean
  error: string | undefined
  data: any | null
  httpStatus: number | undefined
}

export const initialState: HealthScoreAssetState = {
  isLoading: false,
  error: undefined,
  data: null,
  httpStatus: 0
}

const HealthScoreAssetSlice = createSlice({
  name: 'HealthScoreAssetState',
  initialState,
  reducers: {
    HealthScoreAssetLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: null,
        httpStatus: 0
      }
    },
    HealthScoreAssetUpdateAction: (state, action: PayloadAction<{ data: number, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    HealthScoreAssetErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  HealthScoreAssetLoadingAction,
  HealthScoreAssetUpdateAction,
  HealthScoreAssetErrorAction
} = HealthScoreAssetSlice.actions

export default HealthScoreAssetSlice.reducer
